/* assets/anchor-offset.js */
(function () {
  const header = document.querySelector('[role="banner"].site-header');
  const logo   = header ? header.querySelector('.logo-image') : null;

  // extra manual fudge, if you still want more/less
  const EXTRA_OFFSET = -60; // tweak as needed

  const getTranslateY = (el) => {
    if (!el) return 0;
    const t = getComputedStyle(el).transform;
    if (!t || t === 'none') return 0;
    // matrix(a,b,c,d,tx,ty) or matrix3d(...)
    const parts = t.startsWith('matrix3d(')
      ? t.slice(9, -1).split(',')
      : t.startsWith('matrix(')
        ? t.slice(7, -1).split(',')
        : [];
    if (!parts.length) return 0;
    // last value for 2d matrix is ty, for 3d it's index 13
    return t.startsWith('matrix3d(') ? parseFloat(parts[13]) || 0 : parseFloat(parts[5]) || 0;
  };

  const calcOffset = () => {
    const headerH = header ? header.getBoundingClientRect().height : 0;
    const overhang = Math.max(0, getTranslateY(logo)); // only count positive downshift
    return Math.round(headerH + overhang + EXTRA_OFFSET);
  };

  const setScrollPadding = () => {
    // also make native hash jumps land correctly
    document.documentElement.style.scrollPaddingTop = calcOffset() + 'px';
  };

  const scrollToTarget = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = window.scrollY + el.getBoundingClientRect().top;
    const y = top - calcOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  // intercept in-page links
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    e.preventDefault();
    history.pushState(null, '', `#${id}`);
    scrollToTarget(id);
  });

  // handle existing hash on load
  const onLoadHashJump = () => {
    if (location.hash.length > 1) {
      requestAnimationFrame(() => scrollToTarget(location.hash.slice(1)));
    }
  };

  // keep offset accurate on resize and when header classes change (sticky/active)
  const recalc = () => setScrollPadding();
  window.addEventListener('resize', recalc, { passive: true });
  if (header) {
    new MutationObserver(recalc).observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  // initialize
  setScrollPadding();
  onLoadHashJump();

  // expose a tiny debugger
  window.__anchorOffsetDebug = () => ({
    headerHeight: header ? header.getBoundingClientRect().height : 0,
    logoTranslateY: getTranslateY(logo),
    extra: EXTRA_OFFSET,
    total: calcOffset()
  });
})();
